import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Router } from '@angular/router';
import { Azienda } from '../../models/azienda';
import { Tipocommessa } from '../../models/tipocommessa';
import { Gruppo } from '../../models/gruppo';
import { Persona } from '../../models/persona';
import { Commessa } from '../../models/commessa';
import { Lavorazione } from '../../models/lavorazione';
import { Statocommessa } from '../../models/statocommessa';
import { Operaicommessa } from '../../models/operaicommessa';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { configurazione } from '../../../configurazioni/configurazione';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { of } from 'rxjs';
import { AddLavorazioneDialogComponent } from '../add-lavorazione-dialog/add-lavorazione-dialog.component';
import { Orfricliente } from 'src/app/models/orfricliente';

@Component({
  selector: 'app-addcommessa',
  templateUrl: './addcommessa.component.html',
  styleUrls: ['./addcommessa.component.css']
})
export class AddcommessaComponent implements OnInit {
  commessa: Commessa=new Commessa();
  tipocommessa:Tipocommessa;
  tipicommessa:Tipocommessa[];
  hide = true;
//  selectedValueAzienda:number=0;
//  selectedValueTipocommessa:string='';
  selectedValuePersona:number=0;
  aziende: Azienda[]= [];
  aziendeincache: Azienda[]= [];
  aziendefiltrate: Observable<Azienda[]>;
  targhefiltrate: Observable<string[]>;
  telaifiltrati: Observable<string[]>;
  marchefrigofiltrate: Observable<string[]>;
  matricolefrigofiltrate: Observable<string[]>;
  modellifrigofiltrati: Observable<string[]>;
  annifabbricazionefrigofiltrati: Observable<string[]>;
  targhe: string[];
  telai: string[];
  marchefrigo: string[];
  matricolefrigo: string[];
  modellifrigo: string[];
  annifabbricazionefrigo: string[];

  azienda: Azienda;
  persone: Persona[];
  persona: Persona;
  personeAssegnate: Persona[];
  importotale: number=0;
  importotaleivato: number=0;
  rc:number;
  registerForm: FormGroup;
  submitted = false;
  filtroCliente: string;
  nomestato: string;
  stati: Statocommessa[];
  public message =  sessionStorage.getItem('token');
  spinnervalue = 100;
  busy = false;
  Noteamministrazione: string;
  displayedColumns: string[] = [
 //   "Codice",
    "Quantita",
    "Nome",
 //   "articolilavorazione",
 //   "Stato",
    "Importo",
    "Sconto",
    "Subtotale",
    "save",
 
    "delete"];

  sortedDirection:Map<string, boolean>=new Map<string, boolean>();

  lavorazioni: Lavorazione[]=[];
  dataSource = new MatTableDataSource<Lavorazione>(this.lavorazioni);
  orfriclienti: Orfricliente[];
  

//  aziendeCtrl: FormControl;



getAziendaByNome(nome: string):Azienda {
  let azienda:Azienda;
  this.aziende.forEach(a=>{
    if (a.Nome===nome){
      azienda=a;
    }
  });
  return azienda;
}

filtraaziende(name: string) {
    let arr = this.aziende.filter(
      (azienda) => azienda.Nome.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
    return arr.length ? arr : [{ Nome: 'Nessuna azienda trovata'}];
}

  onFiltroAziendaKeyup(event:any){
/*
    if (this.aziendeincache.length==0){
      this.busy = true;
   
        this.commonService.getAllAziendeByTiporelazioneAndFiltro(2, event.target.value).subscribe((res1) => {
        
        this.aziende = res1;
        this.aziendeincache=res1;
        this.aziendefiltrate = of(this.aziende);
              this.aziende.forEach(element => {
                  if (this.commessa.Azienda.Codice === element.Codice){
                    this.azienda=element;
              }
            });
        this.busy = false;
      });  
      
    }

*/
    this.aziende=this.aziendeincache;
  // console.log("Filtro azienda:"+event.target.value);
    if (event.target.value!=undefined){
      this.aziendefiltrate = of(this.aziende.filter(a=> a.Nome.toLowerCase().indexOf(event.target.value.toLowerCase())>-1));
    }
      
  }

  onFiltroTargaKeyup(event:any){
    //this.targhe=[];
    /*
    if (this.azienda!=undefined){
      this.commonService.getAllOrfriclientiByAzienda(this.azienda.Codice).subscribe(res2 => {
        res2.forEach(c => {
          if (c.Attributo==='Targa'){
            this.targhe.push(c.Valore);
          }
        });
        */
        if (event.target.value!=undefined){
          this.targhefiltrate = of(this.targhe.filter(a=> a.indexOf(event.target.value)>-1));
        }
//      });
  //  }

  }

  onFiltroTelaioKeyup(event:any){
//    this.telai=[];
/*    if (this.azienda!=undefined){
      this.commonService.getAllOrfriclientiByAzienda(this.azienda.Codice).subscribe(res2 => {
        res2.forEach(c => {
          if (c.Attributo==='Telaio'){
            this.telai.push(c.Valore);
          }
        });
  */
        if (event.target.value!=undefined){
          this.telaifiltrati = of(this.telai.filter(a=> a.indexOf(event.target.value)>-1));
        }
//      });
//    }
  }

 onFiltroMarcafrigoKeyup(event:any){
        if (event.target.value!=undefined){
          this.marchefrigofiltrate = of(this.marchefrigo.filter(a=> a.indexOf(event.target.value)>-1));
        }
  }
  onFiltroMatricolafrigoKeyup(event:any){
        if (event.target.value!=undefined){
          this.matricolefrigofiltrate = of(this.matricolefrigo.filter(a=> a.indexOf(event.target.value)>-1));
        }
  }
  onFiltroModellofrigoKeyup(event:any){
        if (event.target.value!=undefined){
          this.modellifrigofiltrati = of(this.modellifrigo.filter(a=> a.indexOf(event.target.value)>-1));
        }
  }
  onFiltroAnnofabbricazionefrigoKeyup(event:any){
        if (event.target.value!=undefined){
          this.annifabbricazionefrigofiltrati = of(this.annifabbricazionefrigo.filter(a=> a.indexOf(event.target.value)>-1));
        }
  }

  selectedAziendaOption() {
  this.targhe=[];
  this.telai=[];
  this.marchefrigo=[]; 
  this.matricolefrigo=[];
  this.modellifrigo=[];
  this.annifabbricazionefrigo=[];

  this.registerForm.patchValue({Targaveicolo:""});
  this.registerForm.patchValue({Telaioveicolo:""});
  this.registerForm.patchValue({Marcafrigo:""});
  this.registerForm.patchValue({Matricolafrigo:""});
  this.registerForm.patchValue({Modellofrigo:""});
  this.registerForm.patchValue({Annofabbricazionefrigo:""});

//   const selectedValue = event.option.value;
   this.aziende.forEach(a => {
     if (a.Nome.toLowerCase()===this.registerForm.value.selectedValueAzienda.toLowerCase()){
       this.azienda=a;
         this.commonService.getAllOrfriclientiByAzienda(a.Codice).subscribe(res2 => {
           this.orfriclienti = res2;
           this.orfriclienti.forEach(c => {
             if (c.Attributo==='Targa'){
               this.targhe.push(c.Valore);
             }else if (c.Attributo==='Telaio'){
               this.telai.push(c.Valore);
             }else if (c.Attributo==='Marcafrigo'){
               this.marchefrigo.push(c.Valore);
             }else if (c.Attributo==='Matricolafrigo'){
               this.matricolefrigo.push(c.Valore);
             }else if (c.Attributo==='Modellofrigo'){
               this.modellifrigo.push(c.Valore);
             }else if (c.Attributo==='Annofabbricazionefrigo'){
               this.annifabbricazionefrigo.push(c.Valore);
             }

           });
            this.targhefiltrate = of(this.targhe);
            this.telaifiltrati = of(this.telai);
            this.marchefrigofiltrate = of(this.marchefrigo);
            this.matricolefrigofiltrate = of(this.matricolefrigo);
            this.modellifrigofiltrati = of(this.modellifrigo);
            this.annifabbricazionefrigofiltrati = of(this.annifabbricazionefrigo);
         });
  
        return;
     }
   });
  }

  constructor(private httpClient: HttpClient, private commonService: CommonService,
    private router: Router, private formBuilder: FormBuilder, private dialog: MatDialog) {
      this.persona=new Persona();
      this.azienda=new Azienda();
      this.personeAssegnate=[];
      this.commessa=new Commessa();
      this.filtroCliente="";
      this.nomestato="";
      this.Noteamministrazione="";
    }

  ngOnInit(): void {


    if (this.registerForm===undefined){
    this.registerForm = this.formBuilder.group({
        selectedValueAzienda:['', Validators.required],
        selectedValueTipocommessa:['', Validators.required],
        selectedValueStato:['', Validators.required],
//        selectedValuePersona:[''],
        Codice:[0],
        Numerocommessa:[0],
        Codiceazienda:[0],
        Nomestato:[this.nomestato],
        Dataingresso:[new Date(), Validators.required],
        Datafine:[''],
        Tot:[''],
        Eng:[''],
        Ele:[''],
        Km:[''],
        Marcaveicolo:[''],
        Modelloveicolo:[''],
        Targaveicolo:[''],
        Telaioveicolo:[''],
        Marcafrigo:[''],
        Matricolafrigo:[''],
        Modellofrigo:[''],
        Annofabbricazionefrigo:[''],
        Codicetipocommessa:[0],
        Note:[''],
        Noteofficina:[''],
        Noteamministrazione:['']
        });
    }


    this.busy=true;
    /*
    this.commonService.getAllAziendeByTiporelazione(2).subscribe((res1) => {
      this.aziende = res1;
      this.aziendeincache=res1;
      this.aziendefiltrate = of(this.aziende);
      */
/*
      this.aziendeCtrl = new FormControl();
      this.aziendefiltrate = this.selectedValueAzienda.valueChanges.pipe(
        startWith(''),
        map((azienda) =>
          azienda ? this.filteraziende(azienda) : this.aziende.slice()
        )
        );
*/
      this.commonService.getAllTipicommessa().subscribe((res2) => {
          this.tipicommessa = res2;
          this.commonService.getAllGruppi().subscribe((res3) => {
            let gruppi: Array<Gruppo>= res3;
            let gruppoId=0;
            gruppi.forEach(g => {
              if (g.Nome==='Capo Officina'){
                gruppoId=g.Codice;
              }
            })
            this.commonService.getAllPersoneByGruppoid(gruppoId).subscribe((res4) => {
//          this.commonService.getPersone(this.commonService.currentIstanza.Codice).subscribe((res3) => {
              this.persone = res4;
              this.commonService.getAllStaticommessa().subscribe((res5) => {
                this.stati=res5;

              if (this.commonService.selectedCommessa!=undefined){
                this.commessa=this.commonService.selectedCommessa;
                this.commonService.selectedCommessa=undefined;
                this.nomestato=this.commessa.Statocommessa.Nome;
               // this.Noteamministrazione=this.commessa.Noteamministrazione;
                  if (this.commessa.Azienda!=undefined){
                      this.commonService.getAzienda(this.commessa.Azienda.Codice).subscribe(resAzienda => {
                        this.azienda=resAzienda; 
                        const temp:Azienda[]=[];
                        temp.push(this.azienda);
                        this.aziendefiltrate = of(temp);
                        this.aziendefiltrate.subscribe(value => { 
                          this.registerForm.patchValue({selectedValueAzienda:this.azienda.Nome});
                        });
                      });
                    }
                this.aggiornaLavorazioni();
                /*
                let templavorazioni:Lavorazione[]=[];
        
                this.commonService.getAllLavorazioni(this.commessa.Codice).subscribe((res) => {
                    templavorazioni=res;
                    templavorazioni.forEach(l => {
                      if (l.Importo===undefined || l.Importo===null){
                        l.Importo=0;
                      }
                      if (l.Subtotale===undefined || l.Subtotale===null){
                        l.Subtotale=0;
                      }
                      if (l.Sconto===undefined || l.Sconto===null){
                        l.Sconto=0;
                      }
                      l.Subtotale=l.Importo*(1-l.Sconto/100);
                      this.importotale=this.importotale+l.Subtotale;
                      this.lavorazioni.push(l);
                    });
                    this.dataSource = new MatTableDataSource<Lavorazione>(this.lavorazioni);
*/

                this.commonService.getPersoneByCommessa(this.commessa).subscribe((res4) => {
                    this.personeAssegnate=res4;
                    if (this.personeAssegnate.length>0){
                      this.persona=this.personeAssegnate[0];
                      this.selectedValuePersona=this.persona.Codice;
                    }

                  
                    /*
                    this.aziende.forEach(element => {
                      if (this.commessa.Azienda.Codice === element.Codice){
                        this.azienda=element;
            //          this.selectedValueAzienda=this.azienda.Codice;
                      }
                    });
                    */
                    
                    if (this.tipicommessa!=undefined){
                      this.tipicommessa.forEach(element => {
                        if (element.Codice === this.commessa.Tipocommessa.Codice){
                          this.tipocommessa=element;
                        }
                      });
                    }
                  if (this.commessa.Datafine!=undefined){
        //            this.registerForm.patchValue({Datafine:this.commessa.Datafine});
                  }
                  // Start Retrieve dei campi custom
                  this.targhe=[];
                  this.telai=[];
                  this.marchefrigo=[];
                  this.matricolefrigo=[];
                  this.modellifrigo=[];
                  this.annifabbricazionefrigo=[];
                  this.registerForm.patchValue({Targaveicolo:""});
                  this.registerForm.patchValue({Telaioveicolo:""});
                  this.registerForm.patchValue({Marcafrigo:""});
                  this.registerForm.patchValue({Matricolafrigo:""});
                  this.registerForm.patchValue({Modellofrigo:""});
                  this.registerForm.patchValue({Annofabbricazionefrigo:""});


                    this.commonService.getAllOrfriclientiByAzienda(this.azienda.Codice).subscribe(res2 => {
                      this.orfriclienti = res2;
                      this.orfriclienti.forEach(c => {
                             if (c.Attributo==='Targa'){
                                this.targhe.push(c.Valore);
                              }else if (c.Attributo==='Telaio'){
                                this.telai.push(c.Valore);
                              }else if (c.Attributo==='Marcafrigo'){
                                this.marchefrigo.push(c.Valore);
                              }else if (c.Attributo==='Matricolafrigo'){
                                this.matricolefrigo.push(c.Valore);
                              }else if (c.Attributo==='Modellofrigo'){
                                this.modellifrigo.push(c.Valore);
                              }else if (c.Attributo==='Annofabbricazionefrigo'){
                                this.annifabbricazionefrigo.push(c.Valore);
                              }
                           });
                            this.targhefiltrate = of(this.targhe);
                            this.telaifiltrati = of(this.telai);
                            this.marchefrigofiltrate = of(this.marchefrigo);
                            this.matricolefrigofiltrate = of(this.matricolefrigo);
                            this.modellifrigofiltrati = of(this.modellifrigo);
                            this.annifabbricazionefrigofiltrati = of(this.annifabbricazionefrigo);


                        this.registerForm.patchValue({
                            selectedValueAzienda:this.azienda.Nome,
                            selectedValueTipocommessa:this.tipocommessa.Nome,
                            selectedValueStato:this.commessa.Statocommessa.Nome,
                //            selectedValuePersona:this.persona.Codice,
                            Codice:this.commessa.Codice,
                            Numerocommessa:this.commessa.Numerocommessa,
                            Codiceazienda:this.azienda.Codice,
                            Nomestato:this.commessa.Statocommessa.Nome,
                            Dataingresso:this.commessa.Dataingresso,
                            Datafine:this.commessa.Datafine,
                            Marcaveicolo:this.commessa.Marcaveicolo,
                            Modelloveicolo:this.commessa.Modelloveicolo,
                            Targaveicolo:this.commessa.Targaveicolo,
                            Telaioveicolo:this.commessa.Telaioveicolo,
                            Marcafrigo:this.commessa.Marcafrigo,
                            Matricolafrigo:this.commessa.Matricolafrigo,
                            Modellofrigo:this.commessa.Modellofrigo,
                            Annofabbricazionefrigo:this.commessa.Annofabbricazionefrigo,
                            Codicetipolavorazione:this.tipocommessa.Codice,
                            Note:this.commessa.Note,
                            Noteofficina:this.commessa.Noteofficina,
                            Noteamministrazione:this.commessa.Noteamministrazione,
                            Tot: this.commessa.Tot,
                            Eng: this.commessa.Eng,
                            Ele: this.commessa.Ele,
                            Km: this.commessa.Km,
                          });

                    }); // getAllOrfriclientiByAzienda
                  }); // getPersoneByCommessa
          //      }); // getLavorazioni

              }else{
                this.commessa=new Commessa();
                this.azienda=new Azienda();
                this.tipocommessa=new Tipocommessa();

                this.stati.forEach(s=> {
                  if (s.Nome===this.nomestato){
                    this.commessa.Statocommessa=s;
                    this.commessa.Nomestato=this.nomestato;
                  }
                });
                this.busy=true;
                this.commonService.getAllAziendeByTiporelazione(2).subscribe((res1) => {
                    this.aziende = res1;
                    this.aziendeincache = res1;
                    this.aziendefiltrate = of(this.aziende);
                    this.aziendefiltrate.subscribe(value => {
                      this.busy = false;
                    });
                    
                })
                
              }

            });// getAllStaticommessa
          });// getAllPersoneByGruppoid
        });// getAllGruppi
      }); //getAllTipilavorazione
      this.busy=false;
   // }); //getAllAziende




  }

  manageChangeStato(){
    if (this.registerForm.value.selectedValueStato!=undefined){
      
      this.stati.forEach(element => {
        if (this.registerForm.value.selectedValueStato === element.Nome){
          this.commessa.Statocommessa=element;
          this.registerForm.patchValue({Nomestato:element.Nome});
        }
      });
    }
  }

aggiornaForm(){

        this.aziende.forEach(element => {
          if (this.commessa.Azienda.Codice === element.Codice){
            this.azienda=element;
          }
        });


        if (this.tipicommessa!=undefined){
          this.tipicommessa.forEach(element => {
            if (element.Codice === this.commessa.Tipocommessa.Codice){
              this.tipocommessa=element;
            }
          });
        }

        this.registerForm.setValue({
            selectedValueAzienda:this.azienda.Nome,
            selectedValueTipocommessa:this.tipocommessa.Nome,
            selectedValueStato:this.commessa.Statocommessa.Nome,
      //      selectedValuePersona:this.persona.Codice,
            Codice:this.commessa.Codice,
            Numerocommessa:this.commessa.Numerocommessa,
            Codiceazienda:this.azienda.Codice,
            Nomecliente:this.commessa.Nomecliente,
            Nomestato:this.commessa.Nomestato,
            Dataingresso:this.commessa.Dataingresso,
            Datafine:this.commessa.Datafine,
            Marcaveicolo:this.commessa.Marcaveicolo,
            Modelloveicolo:this.commessa.Modelloveicolo,
            Targaveicolo:this.commessa.Targaveicolo,
            Telaioveicolo:this.commessa.Telaioveicolo,
            Marcafrigo:this.commessa.Marcafrigo,
            Matricolafrigo:this.commessa.Matricolafrigo,
            Modellofrigo:this.commessa.Modellofrigo,
            Annofabbricazionefrigo:this.commessa.Annofabbricazionefrigo,
            Codicetipolavorazione:this.tipocommessa.Codice,
            Note:this.commessa.Note,
            Noteofficina:this.commessa.Noteofficina,
            Noteamministrazione:this.commessa.Noteamministrazione,
            Tot: this.commessa.Tot,
            Eng: this.commessa.Eng,
            Ele: this.commessa.Ele,
            Km: this.commessa.Km,
          });
}

aggiornaLavorazioni(){
    let templavorazioni:Lavorazione[]=[];
      this.commonService.getAllLavorazioni(this.commessa.Codice).subscribe((res) => {
      
        this.lavorazioni=[];
                    templavorazioni=res;
                    this.importotale=0;
                    templavorazioni.forEach(l => {
                      if (l.Importo===undefined || l.Importo===null){
                        l.Importo=0;
                      }
                      if (l.Subtotale===undefined || l.Subtotale===null){
                        l.Subtotale=0;
                      }
                      if (l.Sconto===undefined || l.Sconto===null){
                        l.Sconto=0;
                      }
                      l.Subtotale = Number((l.Quantita * l.Importo * (1 - l.Sconto / 100)).toFixed(2));
                      this.importotale = this.importotale + l.Subtotale;
                      this.importotaleivato = this.importotale * 1.22;
                      this.lavorazioni.push(l);
                    });
                    this.importotale=Number(this.importotale.toFixed(2));
                    this.importotaleivato=Number(this.importotaleivato.toFixed(2));
                    this.dataSource = new MatTableDataSource<Lavorazione>(this.lavorazioni);
                   
                  });
 } 

get f() { return this.registerForm.controls; }

isConmateriali(lavorazione:Lavorazione):boolean{
 
  if (lavorazione.Codicetipolavorazione===1)
    return true
  else return false;

}   

save() {

        this.submitted = true;

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            alert("Errore: verifica i campi indicati con *");
            return;
        }else{

            if (this.registerForm.value.Targaveicolo === '' && this.registerForm.value.Telaioveicolo ===  ''){
              alert("Errore: la targa o il telaio devono essere valorizzati ");
              return;
            }

            this.aziende.forEach(element => {
              if (this.registerForm.value.selectedValueAzienda === element.Nome){
                this.registerForm.value.Codiceazienda=element.Codice;
              }
            });
            this.tipicommessa.forEach(element => {
              if (this.registerForm.value.selectedValueTipocommessa === element.Nome){
                this.registerForm.value.Codicetipocommessa=element.Codice;
              }
            });
            this.persone.forEach(element => {
              if (this.registerForm.value.selectedValuePersona === element.Codice){
                this.persona=element;
              }
            });

            console.log("Save commessa");
    //        console.log("---->"+this.registerForm.value.Dataingresso);
    //        console.log("---->"+this.dateToString(this.registerForm.value.Dataingresso));
            let s=this.dateToString(this.registerForm.value.Dataingresso);
            if (s!=''){
              this.registerForm.value.Dataingresso=s;
            }
            let sf=this.dateToString(this.registerForm.value.Datafine);
            if (sf!=''){
              this.registerForm.value.Datafine=sf;
            }
            this.commonService.saveCommessa(this.registerForm.value).subscribe(data => {
              this.rc=Number(data); //ritorna l'id dell'utente se è stato creato con successo
              //console.log("--->SaveUser"+this.rc.toString());
              if (this.rc===0){
                alert("Commessa già esistente");
              }else if (this.rc===-1){
                alert("Errore creazione commessa");
              }else{
                alert("Commessa salvata con successo");
                this.router.navigate(['commesse']);
              }
              this.router.navigate(['commesse']);
            });

        }
    //    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value))
    }

    manageChangePersona(){
      if (this.selectedValuePersona===undefined || this.selectedValuePersona===0){
        this.persona=new Persona();
       return;
      }
      this.persone.forEach(element => {
        if (this.selectedValuePersona === element.Codice){
          this.persona=element;
        }
      });
    }

    assegna(){
      if (this.persona===undefined){
        return;
      }
      let oc:Operaicommessa=new Operaicommessa();
      oc.commessaId=this.commessa.Codice;
      oc.personaId=this.persona.Codice;
      this.commonService.associateCommessaPersona(oc).subscribe(data1 => {
        let rc1=Number(data1);
        if (rc1===0){
          this.commonService.getPersoneByCommessa(this.commessa).subscribe((res4) => {
              this.personeAssegnate=res4;
              if (this.personeAssegnate.length>0){
                this.persona=this.personeAssegnate[0];
                this.selectedValuePersona=this.persona.Codice;
              }
              this.nomestato='Assegnata';
              alert("Persona assegnata con successo");
              this.router.navigate(['commesse']);
          });
        }else if (rc1===-2){
          alert("Commessa gia' assengata");
        }else if (rc1===-1){
          alert("Errore assegnazione commessa");
        }
      });
    }

    disassegna(){
      if (this.persona===undefined){
        return;
      }
      let oc:Operaicommessa=new Operaicommessa();
      oc.commessaId=this.commessa.Codice;
      oc.personaId=this.persona.Codice;
      this.commonService.disassociateCommessaPersona(oc).subscribe(data1 => {
        let rc1=Number(data1);
        if (rc1===0){
          this.persona=new Persona();
          this.selectedValuePersona=0;
          this.personeAssegnate=[];
          this.nomestato='Preventivo';
          alert("Persona disassegnata con successo");
          this.router.navigate(['commesse']);
        }else if (rc1===-2){
          alert("Commessa non assengata");
        }else if (rc1===-1){
          alert("Errore disassegnazione commessa");
        }
      });
    }
/*
  print(){
    this.commonService.printCommessa(this.commessa).subscribe(data1 => {
        let rc1=Number(data1);
        if (rc1===0){

          alert("Stampa disponibile nei materiali");
         
        }else {
          alert("Errore stampa");
        }
      });
  }
*/
  print(){

  this.commonService.printCommessa(this.commessa.Codice).subscribe({
        next: (blob: Blob) => {
          const fileName = 'commessa_'+this.commessa.Codice+'.pdf'; // nome del file salvato
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          
        },
        error: (err) => {
          alert('Errore durante il download: '+err);
        }
      });

  }

  cancel(){
    this.commonService.selectedCommessa=null;
    this.router.navigate(['commesse']);
    this.filtroCliente="";
  }

  onFiltroClienteKeyup(event:any){
    this.aziende=this.aziendeincache;
    if (event.target.value!=undefined){
      this.filtroCliente="";
      this.aziende = this.aziende.filter(c=> c.Nome.indexOf(event.target.value)>-1);
    }
  }


  isBusy(){
    return this.busy;
  }

  onAziendaFocus(event: FocusEvent) {
    //console.log('selectedValueAzienda focus', event);
    /*
    if (this.aziendeincache.length==0){
      this.busy = true;
      this.commonService.getAllAziendeByTiporelazione(2).subscribe((res1) => {
  
        this.aziende = res1;
        this.aziendeincache=res1;
        this.aziendefiltrate = of(this.aziende);
              this.aziende.forEach(element => {
                  if (this.commessa.Azienda.Codice === element.Codice){
                    this.azienda=element;
              }
            });
        this.busy = false;
      });  
    }
      */
  }

  onAziendaBlur(event: FocusEvent) {
    console.log('selectedValueAzienda blur', event);
    // aggiungi qui la logica da eseguire al blur
  }

  manageChangeAzienda(){
    this.aziende.forEach(element => {
      if (element.Nome === this.registerForm.value.selectedValueAzienda){
        this.azienda=element;
      }
    });
  }

  manageTargaChange(event:any){
    //console.log("Targa change:"+event.target.value);
    let targaselezionata=event.option.value;
    let codiceraggruppamento:string='';
    this.orfriclienti.forEach(c => {
      if (c.Attributo==='Targa' && c.Valore===targaselezionata){
        codiceraggruppamento=c.Codiceraggruppamento;
      }
    });
//    alert("La targa selezionata fa parte del raggruppamento: "+codiceraggruppamento);
    this.orfriclienti.forEach(c => {
      if (c.Codiceraggruppamento===codiceraggruppamento){
        if (c.Attributo==='Telaio'){
          this.registerForm.patchValue({Telaioveicolo:c.Valore});
        }else if (c.Attributo==='Marcafrigo'){
          this.registerForm.patchValue({Marcafrigo:c.Valore});
        }else if (c.Attributo==='Matricolafrigo'){
          this.registerForm.patchValue({Matricolafrigo:c.Valore});
        }else if (c.Attributo==='Modellofrigo'){
          this.registerForm.patchValue({Modellofrigo:c.Valore});
        }else if (c.Attributo==='Annofabbricazionefrigo'){
          this.registerForm.patchValue({Annofabbricazionefrigo:c.Valore});
        }
      }
    });
  }

  /*
  manageChangeTipolavorazione(){
    this.tipicommessa.forEach(element => {
      if (element.Nome === this.registerForm.value.selectedValueTipolavorazione){
        this.tipocommessa=element;
      }
    });
  }
*/
  onNomeKeyup(l:Lavorazione, event:any){
   
      l.Nome=event.target.value;
  }

  onQuantitaKeyup(l:Lavorazione, event:any){
    if (isNaN(event.target.value)){
      event.target.value=l.Quantita;
    }else{
      l.Quantita=Number(event.target.value);
    }
    l.Subtotale=Number((l.Quantita*l.Importo*(1-l.Sconto/100)).toFixed(2));
  }

  onImportoKeyup(l:Lavorazione, event:any){
    if (isNaN(event.target.value)){
      event.target.value=l.Importo;
    }else{
      l.Importo=Number(event.target.value);
    }
    l.Subtotale=Number((l.Quantita*l.Importo*(1-l.Sconto/100)).toFixed(2));
  }

  onScontoKeyup(l:Lavorazione, event:any){
    if (isNaN(event.target.value)){
      event.target.value=l.Sconto;
    }else{
      l.Sconto=Number(event.target.value);
    }
    l.Subtotale=Number((l.Quantita*l.Importo*(1-l.Sconto/100)).toFixed(2));
  }

  onTotaleKeyup(t: number, event: any) {
    if (isNaN(event.target.value)) {
      event.target.value = t;
    } else {
      t = Number(event.target.value);
    }
    t = Number((t).toFixed(2));
  }


  isReadonlyLavorazione(l: Lavorazione){
    return l.Statolavorazione.Nome==='Conclusa';
  }

  isTipolavorazioneMateriali(l: Lavorazione):boolean {
    
    return l.Tipolavorazione.Codice === 1;
  }

  saveLavorazione(l: Lavorazione){
    this.commonService.saveLavorazione(l).subscribe((data) => {
      let rc: number;
      rc=Number(JSON.stringify(data));
      if (rc>0){
      //  alert("Lavorazione salvata con successo");
        this.aggiornaLavorazioni();
      }else{
        alert("Errore salvataggio lavorazione");
      }
    });
  }

   deleteLavorazione(l: Lavorazione){
    // Dialog box di conferma
    const conferma = confirm("Sei sicuro di voler eliminare questa lavorazione?");
    
    if (conferma) {
      this.commonService.deleteLavorazione(l).subscribe((data) => {
        let rc: number;
        rc=Number(JSON.stringify(data));
        if (rc>0){
       //   alert("Lavorazione eliminata con successo");
          this.aggiornaLavorazioni();
        }else{
          alert("Errore eliminazione lavorazione");
        }
       });
    }
  }

  articolilavorazione(lavorazione: Lavorazione): void {
      this.commonService.selectedCommessa=this.commessa;
      this.commonService.selectedLavorazione=lavorazione;
      this.router.navigate(['lavorazionearticoli']);
  }

  addLavorazione() {
    const dialogRef = this.dialog.open(AddLavorazioneDialogComponent, {
      width: '800 px',
      data: { codicelavorazione:0, codicecommessa: this.commessa.Codice, codicestatolavorazione:1, codicetipolavorazione:2 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Gestisci il risultato (la lavorazione salvata)
        //console.log('Lavorazione salvata:', result);
        this.aggiornaLavorazioni();
        // Qui puoi aggiungere la lavorazione alla lista delle lavorazioni
       } 
    });
  }
    


  dateToString(d: Date): string {
    //let s:string='9999-12-31';
    let s:string='';
    if(d!=undefined){
      if (d instanceof Date){
//        console.log("--->"+d);
      }else{
        return '';
      }
      let month:string = (d.getMonth()+1).toString();
      if ((d.getMonth()+1)<10){
        month='0'+month;
      }

      let year = d.getFullYear().toString();
      let day = d.getDate().toString();
      if (d.getDate().toString().length == 1){
        day='0'+day;
      }
      s=year+'-'+month+'-'+day;
    }
    return s;
  }


  myFilter(d: Date): boolean {
  //		const selectinableday = d.getDay();
  //console.log("---->"+d);
    if(d!=undefined){
      const selectinablemonth = d.getMonth();
      const selectinableyear = d.getFullYear();
      const selectinableday = d.getDate();
      const todaysDateObject = new Date();
      const actualday = todaysDateObject.getDate();
      const actualmonth = todaysDateObject.getMonth();
      const actualyear = todaysDateObject.getFullYear();
      if (actualyear - 11> selectinableyear){
        return true;
      }else{
        return false;
      }
    }
    return false;
  }
  getConfigurazione(){
    return configurazione.addcommessa;
  }
}
